import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionText?: string;
  actionTo?: string;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  actionText = '返回首页',
  actionTo = '/',
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4">
      <span className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 text-foreground-300 mb-5">
        <i className={`${icon} text-4xl`}></i>
      </span>
      <h3 className="text-base md:text-lg font-semibold text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-500 max-w-md leading-relaxed">{description}</p>
      )}
      <Link
        to={actionTo}
        className="mt-6 inline-flex items-center gap-1.5 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-line"></i>
        {actionText}
      </Link>
    </div>
  );
}